import styled from 'styled-components';

export const InsiderTradingAccordionWrapper = styled('section')`
  margin-bottom: ${({ theme }) => theme.x5spacePx}px;
`;

export const CardWrapper = styled('div')`
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
